// extracted by mini-css-extract-plugin
export default {"images":"DBbNS","image":"SYEEQ","item":"CBkh2"};